// function addToCart(artNo: string) {
//     // var basketProducts = JSON.parse(localStorage.getItem("basketProducts"));
//     // var basketBtn = document.getElementById("basket-product");

//     // var removeObject = false;
//     //  if(basketProducts == null) {
//     //     basketProducts = [];
//     // }
//     // else {
//     //     for(var i = 0; i < basketProducts.length; i++){
//     //         if(basketProducts[i].artNo == artNo){
//     //             basketProducts.splice(i, 1);
//     //             removeObject = true;
//     //             basketBtn.classList.remove("inBasket");
//     //         }
//     //     }
//     // }
//     // var product = {        
//     //     "artNo": artNo,        
//     // };

//     // if(removeObject == false){
//     //     basketProducts.push(product);
//     //     basketBtn.classList.add("inBasket");
//     // }

//     // localStorage.setItem("basketProducts", JSON.stringify(basketProducts));
//     console.log(artNo);
// }
